import { SystemActionsList } from '@wix/editor-platform-host-integration-apis';
import { ContributedPlatformActionsDict } from '../types';
import { upgradeActionFactory } from './upgradeActionFactory';

export const platformSystemActions: ContributedPlatformActionsDict = {
  [SystemActionsList.upgrade]: upgradeActionFactory,
};
